import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModelSurveys } from "wint-api-client/dist/types";
import useAPIClientHelper from "./useAPIClientHelper";
import { ServiceConstants } from "utils/constants";

function useSurveyService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getSurvey = (id: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .SurveyClient.Get(id)
      .then((res) => res.data);
  };

  const getSurveyStatus = (id: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .SurveyClient.GetSurveyStatus(id)
      .then((res) => res.data);
  };

  const saveSurvey = (response: WintSuperkollAPIModelSurveys.SurveyResponseInputModel) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).SurveyClient.SaveResponse(response);
  };

  const sendToPerson = (surveyId: string, request: WintSuperkollAPIModelSurveys.SurveySendToPersonAction) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).SurveyClient.SendToPerson(
      surveyId,
      request
    );
  };

  const getSurveyPersons = (searchStr: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .SurveyClient.GetSurveyPersons({
        ...ServiceConstants.DefaultFilter,
        searchStr: searchStr
      })
      .then((res) => (res.data.items ? res.data.items : []));
  };

  const getSuggestedSurveyPersons = () => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .SurveyClient.GetSurveyPersonSuggestions({
        count: ServiceConstants.SuggestionsCount
      })
      .then((res) => (res.data.items ? res.data.items : []));
  };

  const addSurveyComment = (id: string, message: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .SurveyClient.AddSurveyComment(id, { message })
      .then((res) => res.data);
  };

  const getFileContent = (id: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .SurveyClient.GetAttachment(id)
      .then((res) => res.data.data ?? "");
  };

  return {
    getSurvey,
    getSurveyStatus,
    saveSurvey,
    sendToPerson,
    getSurveyPersons,
    getSuggestedSurveyPersons,
    addSurveyComment,
    getFileContent
  };
}

export default useSurveyService;
